<ph-empty-state icon="chat-circle-dots"
                [attr.center]="center ? '' : null"
                [heading]="enabled ? 'AI chatbot is on for your website' : 'AI chatbot is off for your website'">
    {{ (enabled ? 'It helps' : 'It can help')
        + ' visitors find information about your community, answer common questions, and get to the homeowner portal.' }}
    <ng-container *ngIf="canConfigure">
        {{ ' Upload your CC&Rs, bylaws, and community documents on its configuration page so it can answer community-specific questions.' }}
    </ng-container>

    <ph-button slot="actions" variant="secondary" mode="filled" size="small" type="button"
               icon="info"
               (click)="howItWorksOpen = true">How it works</ph-button>
    <ph-button slot="actions" *ngIf="canConfigure && showConfigure"
               variant="primary" mode="filled" size="small" type="button"
               trailing-icon="arrow-up-right"
               [routerLink]="['/app/other-tools/ai-chatbot']"
               (click)="configure.emit()">Configure AI chatbot</ph-button>
</ph-empty-state>

<app-penny-how-it-works-dialog [open]="howItWorksOpen" (closed)="howItWorksOpen = false"></app-penny-how-it-works-dialog>
